var _style, _rect, _path, _path2, _g, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 628,
      height: 628
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n     .line-3d-printing1-overall {animation:line-3d-printing1-overall 10s infinite;}\n     @keyframes line-3d-printing1-overall {\n         0%{transform: translate3d(0, 0, 0);}\n         10%{transform: translate3d(0, 0, 0);}\n         15%{transform: translate3d(0, 14px, 0);}\n         35%{transform: translate3d(0, 14px, 0);}\n         40%{transform: translate3d(0, 0, 0);}\n         65%{transform: translate3d(0, 0, 0);}\n         70%{transform: translate3d(0, 14px, 0);}\n         85%{transform: translate3d(0, 14px, 0);}\n         90%{transform: translate3d(0, 0, 0);}\n         100%{transform: translate3d(0, 0, 0);}\n     }\n     .line-3d-printing1-tool {animation:line-3d-printing1-tool 10s infinite;}\n     @keyframes line-3d-printing1-tool {\n         0%{transform: translate3d(0, 0, 0);}\n         10%{transform: translate3d(0, 0, 0);}\n         15%{transform: translate3d(0, 0, 0);}\n         20%{transform: translate3d(-3px, 0, 0);}\n         25%{transform: translate3d(3px, 0, 0);}\n         30%{transform: translate3d(0, 0, 0);}\n         45%{transform: translate3d(0, 0, 0);}\n         55%{transform: translate3d(0, 0, 0);}\n         65%{transform: translate3d(-25px, 0, 0);}\n         75%{transform: translate3d(-25px, 0, 0);}\n         80%{transform: translate3d(-20px, 0, 0);}\n         85%{transform: translate3d(-25px, 0, 0);}\n         90%{transform: translate3d(-25px, 0, 0);}\n         100%{transform: translate3d(0, 0, 0);}\n     }\n     @media (prefers-reduced-motion: reduce) {\n         .line-3d-printing1-overall, .line-3d-printing1-tool {\n             animation: none;\n         }\n     }\n    ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fill1 stroke1",
    x: 9,
    y: 9,
    width: 83,
    height: 84,
    rx: 4,
    fill: "rgba(244,241,222,1)",
    stroke: "rgba(0,0,0,1)",
    strokeWidth: "2.6px"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill1 stroke1",
    d: "M23 71C23 69.8954 23.8954 69 25 69H76C77.1046 69 78 69.8954 78 71V75H23V71Z",
    fill: "rgba(244,241,222,1)",
    strokeWidth: "2.6px"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fill1 stroke1",
    d: "M78 75V71C78 69.8954 77.1046 69 76 69H25C23.8954 69 23 69.8954 23 71V75M78 75H23M78 75H86V15H15V75H23",
    stroke: "rgba(0,0,0,1)",
    strokeWidth: "2.6px"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "line-3d-printing1-overall fill1 stroke1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fill2 stroke2",
    x: 15,
    y: 29,
    width: 71,
    height: 7,
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: "2.6px"
  }), /*#__PURE__*/React.createElement("g", {
    className: "line-3d-printing1-tool fill2 stroke2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill2 stroke2",
    d: "M59 24C59 23.4477 59.4477 23 60 23H72C72.5523 23 73 23.4477 73 24V42C73 42.5523 72.5523 43 72 43H70H62H60C59.4477 43 59 42.5523 59 42V24Z",
    fill: "#FFF",
    strokeWidth: "2.6px"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill2 stroke2",
    d: "M62 43V48H70V43H62Z",
    fill: "#FFF",
    strokeWidth: "2.6px"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill2 stroke2",
    d: "M70 48H62L65.1318 53.4806C65.5157 54.1524 66.4843 54.1524 66.8682 53.4806L70 48Z",
    fill: "#FFF",
    strokeWidth: "2.6px"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill2 stroke2",
    d: "M62 43H60C59.4477 43 59 42.5523 59 42V24C59 23.4477 59.4477 23 60 23H72C72.5523 23 73 23.4477 73 24V42C73 42.5523 72.5523 43 72 43H70M62 43V48M62 43H70M62 48H70M62 48L65.1318 53.4806C65.5157 54.1524 66.4843 54.1524 66.8682 53.4806L70 48M70 48V43",
    stroke: "#000",
    strokeWidth: "2.6px"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fill2 stroke2",
    cx: 20,
    cy: 84,
    r: 4,
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: "2.6px"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "fill2 stroke2",
    cx: 33,
    cy: 84,
    r: 4,
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: "2.6px"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "fill2 stroke2",
    cx: 46,
    cy: 84,
    r: 4,
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: "2.6px"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg1.b6c37216e5ea2cf2ed965dd263846542.svg";
export { ForwardRef as ReactComponent };